(function ($) {
// Collection wishlist
document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

var html = document.documentElement;
var isMacLike = !!navigator.platform && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
if (isMacLike) {
    html.classList.add("isMac");
}

// Check with brower safari
if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {
    html.classList.add("isSafari");
}

// Template collection customer review
if ($(window).width() < 769) {
    $(".template-collection .reviews-customer--mob-carousel .js-reviews-customer-carousel").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true
    });
} else {
    $(".template-collection .reviews-customer--carousel .js-reviews-customer-carousel").slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: true
    });
}

// Home brand slider — unslick/reinit on breakpoint change (rows mode breaks with responsive[])
var homeBrandBreakpointKey = null;
var homeBrandResizeTimer = null;

function getHomeBrandBreakpointKey() {
    var width = window.innerWidth;

    if (width <= 767) {
        return "mobile";
    }

    if (width <= 1200) {
        return "tablet";
    }

    return "desktop";
}

function getHomeBrandSliderSettings(slideCount) {
    var width = window.innerWidth;
    var settings;
    var visibleSlides;

    if (width <= 767) {
        visibleSlides = 6;
        settings = {
            infinite: true,
            rows: 2,
            slidesPerRow: 1,
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: true,
            dots: false
        };
    } else if (width <= 1200) {
        visibleSlides = 4;
        settings = {
            infinite: true,
            rows: 1,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false
        };
    } else {
        visibleSlides = 5;
        settings = {
            infinite: true,
            rows: 1,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            dots: false
        };
    }

    if (slideCount <= visibleSlides) {
        settings.infinite = false;
    }

    // left positioning instead of translate3d — Safari Retina blurs bitmaps in GPU layers.
    settings.useTransform = false;
    settings.useCSS = false;

    return settings;
}

function initHomeBrandSlider(slider, forceReinit) {
    var $slider = $(slider);

    if (!$slider.length || !$slider.children(".item").length) {
        return;
    }

    var section = slider.closest(".home-brand-slide");

    if (section && window.getComputedStyle(section).display === "none") {
        return;
    }

    if ($slider.hasClass("slick-initialized")) {
        if (!forceReinit) {
            return;
        }

        $slider.slick("unslick");
    }

    var slideCount = $slider.children(".item").length;

    $slider.slick(getHomeBrandSliderSettings(slideCount));
}

function initAllHomeBrandSliders(forceReinit) {
    $(".js-home-brand-slider, .home-brand .item-brand").each(function () {
        initHomeBrandSlider(this, forceReinit);
    });
}

function handleHomeBrandSliderResize() {
    var currentBreakpoint = getHomeBrandBreakpointKey();

    if (homeBrandBreakpointKey !== null && homeBrandBreakpointKey !== currentBreakpoint) {
        homeBrandBreakpointKey = currentBreakpoint;
        initAllHomeBrandSliders(true);
        return;
    }

    homeBrandBreakpointKey = currentBreakpoint;

    $(".js-home-brand-slider:not(.slick-initialized), .home-brand .item-brand:not(.slick-initialized)").each(function () {
        initHomeBrandSlider(this, false);
    });

    $(".js-home-brand-slider.slick-initialized, .home-brand .item-brand.slick-initialized").each(function () {
        $(this).slick("setPosition");
    });
}

$(document).ready(function () {
    homeBrandBreakpointKey = getHomeBrandBreakpointKey();
    initAllHomeBrandSliders(false);
});

$(window).on("load", function () {
    initAllHomeBrandSliders(false);
    $(".js-home-brand-slider.slick-initialized, .home-brand .item-brand.slick-initialized").each(function () {
        $(this).slick("setPosition");
    });
});

$(window).on("resize orientationchange", function () {
    clearTimeout(homeBrandResizeTimer);
    homeBrandResizeTimer = setTimeout(handleHomeBrandSliderResize, 150);
});

document.addEventListener("shopify:section:load", function (event) {
    if ($(event.target).find(".js-home-brand-slider, .home-brand .item-brand").length) {
        initAllHomeBrandSliders(false);
    }
});
// Home slider banner
function syncSlideshowMobileSlideHeights(slider) {
    var $slider = $(slider);

    if (!$slider.hasClass("slick-initialized")) {
        return;
    }

    if (window.innerWidth >= 768) {
        $slider.find(".slick-slide").css("height", "");
        return;
    }

    var maxHeight = 0;

    $slider.find(".slick-slide").not(".slick-cloned").each(function () {
        $(this).css("height", "auto");
        $(this).find(".slide-item-details--mobile-media-only .slider-image").css("height", "auto");
    });

    $slider.find(".slick-slide").not(".slick-cloned").each(function () {
        maxHeight = Math.max(maxHeight, $(this).outerHeight());
    });

    if (maxHeight > 0) {
        $slider.find(".slick-slide").css("height", maxHeight + "px");
    }

    $slider.find(".slide-item-details--mobile-media-only .slider-image").css("height", "auto");
}

function initSlideshowSlider(slider) {
    var $slider = $(slider);

    if ($slider.hasClass("slick-initialized")) {
        return;
    }

     
    var autoplay = $slider.attr("data-autoplay-slideshow") === "true";
     var sectionSpeed = parseInt($slider.attr("data-autoplay-speed")) || 5000;

        $slider.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: false,
        adaptiveHeight: false
        });

        if (autoplay) {
        function getSlideSpeed(slider) {
            var currentSlide = $(slider).find('.slick-current');
            var slideSpeed = currentSlide.attr('data-slide-speed');
            // video block has its own speed, image falls back to section setting
            return slideSpeed ? parseInt(slideSpeed) : sectionSpeed;
        }

        var autoplayTimer;

        function scheduleNext(slider) {
            clearTimeout(autoplayTimer);
            autoplayTimer = setTimeout(function () {
            $(slider).slick('slickNext');
            scheduleNext(slider);
            }, getSlideSpeed(slider));
        }

        scheduleNext($slider[0]);

        $slider.on('afterChange', function () {
            scheduleNext($slider[0]);
        });
        }

    $slider.off("setPosition.slideshowHeights afterChange.slideshowHeights init.slideshowHeights");
    $slider.on("setPosition.slideshowHeights afterChange.slideshowHeights init.slideshowHeights", function () {
        syncSlideshowMobileSlideHeights(slider);
    });

    syncSlideshowMobileSlideHeights(slider);

    if (typeof window.initSlideshowVideos === "function") {
        window.initSlideshowVideos(slider.closest(".slider-custom") || document);
    }

    if (typeof window.bindSlideshowVideoSliderEvents === "function") {
        window.bindSlideshowVideoSliderEvents();
    }
}

function reinitSlideshowSliders(container) {
    $(container)
        .find(".slider-custom .slider-item")
        .each(function () {
            var $slider = $(this);

            if ($slider.hasClass("slick-initialized")) {
                $slider.slick("unslick");
            }

            initSlideshowSlider(this);
        });
}

function windowResizeFunc() {
    $(".slider-custom .slider-item").each(function () {
        initSlideshowSlider(this);
    });
}

windowResizeFunc();

$(window).on("resize orientationchange", function () {
    windowResizeFunc();
    $(".slider-custom .slider-item.slick-initialized").each(function () {
        syncSlideshowMobileSlideHeights(this);
    });
});

document.addEventListener("shopify:section:load", function (event) {
    reinitSlideshowSliders(event.target);
});

// Home page block text
if ($(window).width() > 650) {
    $(".content-show-more").readmore({
        speed: 500,
        collapsedHeight: 100,
        collapsedMoreHeight: 100,
        moreLink: '<a class="show-more" href="#">Show more</a>',
        lessLink: '<a class="show-less" href="#">Less</a>'
    });
} else {
    $(".content-show-more").readmore({
        speed: 500,
        collapsedHeight: 145,
        collapsedMoreHeight: 145,
        moreLink: '<a class="show-more" href="#">Show more</a>',
        lessLink: '<a class="show-less" href="#">Less</a>'
    });
}

// Menu secondary mobile
$(document).ready(function () {
    $(".overlay-menu").on("click", function () {
        $(this).parents(".menu-drawer-container").removeAttr("open");
    });
});

// Collection page
$(".collection__description").readmore({
    speed: 500,
    collapsedHeight: 100,
    collapsedMoreHeight: 100,
    moreLink: '<a class="show-more" href="#">Show more</a>',
    lessLink: '<a class="show-less" href="#">Less</a>'
});

// FAQs section
// $(".section-faqs .section-faqs__answer").readmore({
//     speed: 500,
//     collapsedHeight: 135,
//     collapsedMoreHeight: 135,
//     moreLink: '<div class="section-faqs__more-button-wrapper"><a class="show-more section-faqs__more-button" href="#">More</a></div>',
//     lessLink: '<div class="section-faqs__more-button-wrapper"><a class="show-less section-faqs__more-button" href="#">Less</a></div>'
// });

// Mega menu
$(".mobile-nav__item--sub a.mobile-nav__link .dropdown-menu .js-toggle-trigger").on("click", function () {
    $(this).parents(".mobile-nav__item--sub").toggleClass("active");
});

$(window).scroll(function () {
    if ($(this).scrollTop() > 90) {
        $("body").addClass("scrolling-menu");
    } else {
        $("body").removeClass("scrolling-menu");
    }
});

$(document).on("click", ".dropdown-menu .js-toggle-trigger", function (e) {
    var $parent = $(this).closest(".mobile-nav__item--sub");
    var $currentMenu;
    
    if ($parent.length) {
        $currentMenu = $parent;
    } else {
        $currentMenu = $(this).closest("li");
    }
    
    // $(".mobile-nav__item--sub.active").not($currentMenu).removeClass("active");
    
    $currentMenu.addClass("mobile-nav__item--sub").toggleClass("active");
    e.stopPropagation();
});

$(document).on("click", ".menu-parents__no-link", function (e) {
    e.preventDefault();
    var $parent = $(this).closest(".mobile-nav__item--sub");
    
    if ($parent.length) {
        // $(".mobile-nav__item--sub.active").not($parent).removeClass("active");
        $parent.toggleClass("active");
    }
    e.stopPropagation();
});

$(document).on("click", ".menu_child_item .js-toggle-trigger, .menu-no-link .mobile-menu__sub_link_wrapper", function (e) {
    $(this).closest(".menu_child_item").toggleClass("active_menu_child");
    e.preventDefault();
    e.stopPropagation();
});

$(document).on("click", ".menu_close__header", function () {
    $(".menu-drawer-container").removeAttr("open");
    $("body").find(".mobile-nav__item--sub").removeClass("active");
});


// Mega menu hover - add active-hover class on hover
$(document).ready(function () {
    $(".primary-nav__item, .nav__sub, .nav__sub--cta").on("mouseenter", function () {
        $(this).addClass("active-hover");
    });

    $(".primary-nav__item, .nav__sub, .nav__sub--cta").on("mouseleave", function () {
        $(this).removeClass("active-hover");
    });

    $(document).on("mouseover", function (e) {
        if (!$(e.target).closest(".primary-nav__item, .nav__sub, .nav__sub--cta").length) {
            $(".primary-nav__item, .nav__sub, .nav__sub--cta").removeClass("active-hover");
        }
    });
});


// ===========================
// Product Detail
// ===========================
// $('.js-swatch-variant-title').text($('.js-swatch-color-item :radio:checked').val());

$(".product-name--gift-card .product-detail-description h3").on("click", function () {
    $(this).parents(".product-detail-description").toggleClass("active");
});

// Anchor on PDP
$(document).ready(function () {
    $(".tab-item:first-child").addClass("active");

    $(".tab-accordion li a").bind("click", function (event) {
        var $anchor = $(this);
        // Sticky tab on PDP
        if ($(window).width() > 1023) {
            $(this).parents(".tab-accordion").addClass("sticky");
            $(this).parents("body").addClass("sticky");
        }

        $(".tab-item.active").not($anchor).removeClass("active");
        $(this).parent().addClass("active");
        $("html, body").stop().animate({
            scrollTop: $($anchor.attr("href")).offset().top - 70
        }, 1000);

        event.preventDefault();
    });

    // Sticky tab on PDP
    if ($(window).width() > 1023) {
        $(".tab-accordion li:first-child").bind("click", function (event) {
            $(this).parents(".tab-accordion").removeClass("sticky");
            $(this).parents("body").removeClass("sticky");
        });

        $(window).scroll(function () {
            if ($(this).scrollTop() > 1400) {
                $(".tab-accordion").addClass("sticky");
            } else {
                $(".tab-accordion").removeClass("sticky");
            }
        });
    }

    $(window).scroll(function () {
        if ($(this).scrollTop() > 1400) {
            $("body").addClass("sticky");
        } else {
            $("body").removeClass("sticky");
        }
    });
    // End Sticky tab on PDP

    // Header sticky
    if ($(window).width() > 1024) {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 50) {
                $("body").addClass("sticky-header");
            } else {
                $("body").removeClass("sticky-header");
            }
        });

        $(window).scroll(function () {
            if ($(this).scrollTop() > 300) {
                $("body").addClass("sticky-hidden-size");
            } else {
                $("body").removeClass("sticky-hidden-size");
            }
        });
    }

    // Stiky PDP bottom button
    if ($('[class^="template-product-default-"]').length != 1) {
        if ($(window).width() > 1024) {
            $(window).scroll(function () {
                if ($(this).scrollTop() > 500) {
                    $("body").addClass("sticky-button");
                } else {
                    $("body").removeClass("sticky-button");
                }
            });
        } else {
            $(window).scroll(function () {
                if ($(this).scrollTop() > 1000) {
                    $("body").addClass("sticky-button");
                } else {
                    $("body").removeClass("sticky-button");
                }
            });
        }

        // End Stiky PDP bottom button
        if ($(window).width() > 640 && $(window).width() < 1023) {
            $(window).scroll(function () {
                if ($(this).scrollTop() > 1200) {
                    $("body").addClass("sticky-button");
                } else {
                    $("body").removeClass("sticky-button");
                }
            });
        }
    }

    $(document).on("click", ".js-faqs-title", function () {
        $(this).parent().toggleClass("active").find(".faqs__answer").slideToggle(200);
    });

    if ($(".cms-campaign").length) {
        $("body").addClass("campaign-template");
    } else {
        $("body").removeClass("campaign-template");
    }
    $(document).on("click", ".show-more", function () {
        $(".product-detail-description").addClass("hidden-overlay");
    });
    $(document).on("click", ".show-less", function () {
        $(".product-detail-description").removeClass("hidden-overlay");
    });

    // Section FAQs - More/Less toggle (hide from 2nd item when collapsed)
    $(document).on("click", ".section-faqs .section-faqs__more-button", function () {
        var $btn = $(this);
        var $section = $btn.closest(".section-faqs");
        var $moreItems = $section.find(".section-faqs__more-items");

        if (!$moreItems.length) return;

        var isExpanded = $section.hasClass("is-expanded");
        var nextExpanded = !isExpanded;

        $section.toggleClass("is-expanded", nextExpanded);
        $moreItems.prop("hidden", !nextExpanded);
        $btn.attr("aria-expanded", nextExpanded ? "true" : "false");

        var moreText = $btn.attr("data-more-text") || $btn.text();
        var lessText = $btn.attr("data-less-text") || $btn.text();
        $btn.text(nextExpanded ? lessText : moreText);
    });

    if ($(".product-detail-description .main-content-detail").outerHeight() == 0) {
        $(".product-detail-description").addClass("no-desc");
    }
    if ($(".product-detail-description .main-content-detail").outerHeight() < 250.99) {
        $(".product-detail-description").addClass("no-more");
    }

    $(".banner-text-with-image-product table tr td").each(function () {
        var set = $(this).find("figure");
        if (set.hasClass("image")) {
            set.parent().addClass("col-image");
        } else {
            set.parent().removeClass("col-image");
        }
    });

    if (navigator.userAgent.indexOf("Mac") > 0) {
        $("body").addClass("mac-os");
    }
});

// slick product thumbnail
$(".main_images.slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".slider-nav"
});

$(".product__media-list.slider-nav").slick({
    slidesToShow: 3, slidesToScroll: 1, asNavFor: ".slider-for",
    // dots: true,
    focusOnSelect: true
});

// Slick image on mobile PDP
$(".product-slider-mobile ul").slick({
    dots: true,
    speed: 1000,
    infinite: true,
    prevArrow: false,
    nextArrow: false,
    autoplay: false,
    // autoplaySpeed: 3000
});

// PDP calculator remove event default
$(".oct-calculator-open").on("click", function (e) {
    e.preventDefault();
});

// Blog detail
$(".share-button__button").on("click", function () {
    $(this).parent(".share-blog").toggleClass("active");
});

// Count minicart ajax
$(document).ready(function () {
    $(".js-ajax-add-to-cart").click(function () {
        setTimeout(function () {
            $.getJSON("/cart.js", function (cart) {
                $("span.count").html("View my cart" + "(" + cart.item_count + ")");
            });
        }, 200);

        // Only scroll if the button does NOT have class 'btn-quick-buy'
        if (!$button.hasClass("btn-quick-buy") && $('[class^="template-product-default-"]').length != 1) {
            $("html, body").animate({
                scrollTop: 0
            }, "slow");
        }

        // Picky app add to cart
        // setTimeout(function(){
        // $('.picky-add-selected-to-cart-button').trigger("click");
        // }, 2000)
    });
});

$(document).ready(function () {
    $(".js-ajax-cart-drawer-trigger").click(function () {
        window.location.href = "/cart";
    });
});

if ($('.ajax-cart-item__title:contains("Gift Card")').length > 0) {
    $(this).parent(".content-minicart").addClass("removeFa");
}

// PDP bundle
$(document).ready(function () {
    $(".picky-bundler-container h4").on("click", function () {
        $(this).parents(".picky-bundler-container").toggleClass("active-bundle");
    });
});

// Add view more button on collection page
setTimeout(function () {
    $(".collection-list #product-grid li.active").nextAll().hide();
    $(".view-all").show();
}, 3000);

$(".collection-list .view-all").on("click", function () {
    $("#product-grid li.active").nextAll().show();
    $(".view-all").hide();
});

// $(document).delegate('.js-load-more','click', function(){
//     var $this =$(this),
//     totalPages = parseInt($this.attr('data-max')),
//     currentPage = parseInt($this.attr('data-current'));
//     $this.attr('disabled', true);
//     $this.find('.load-more-text').addClass('hide');
//     $this.find('[loader]').removeClass('hide');
//     var nextUrl = $this.attr('data-next-link');
//     var current_page_new = currentPage + 1;
//     var next_coll = currentPage + 2;
//     var parser = document.createElement('a');
//     parser.href = window.location.href;
//     var query = parser.search.substring(1);
//     if(currentPage >= totalPages) {
//         $this.find('.load-more-text').text('Products Finished').removeClass('hide'); $this.find('[loader]').addClass('hide');
//         return;

//     }
//     $.ajax({
//         url: nextUrl,
//         type: 'GET',
//         dataType: 'html',
//         success: function(responseHTML){
//             $this.attr('data-next-link', window.location.pathname + "?page="+next_coll +'&'+ query);
//             $this.attr('data-current', current_page_new);
//             $('.grid--view-items').append($(responseHTML).find('.grid--view-items').html());
//         },

//         complete: function() {
//             if(current_page_new < totalPages) {
//                 $this.attr('disabled', false); $this.find('.load-more-text').removeClass('hide'); $this.find('[loader]').addClass('hide');
//             }
//             if(current_page_new >= totalPages) {
//                 $this.find('.load-more-text').text('Products Finished').removeClass('hide'); $this.find('[loader]').addClass('hide');
//             }

//             //swym collections wishlist button dynamic initialization
//             document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

//             // Fix yotpo not showing in collection when load more
//             var api = new Yotpo.API(yotpo);
//             api.refreshWidgets();
//         }
//     })

// });

// remove spacing when show Products Finished
// $('button.btn.js-load-more.button-view-all:disabled').parents(".load-more_wrap").addClass('active-hidden');

// Gift cart
$("body").on("click", ".swatch-element", function () {
    $(".product-name--gift-card .swatch-element").removeClass("change-bg");
    $(".select-swatch-value").removeClass("remove-bg-selected");
    $(this).addClass("change-bg");
    var thisVariantName = $(this).data("value").replace(/[^a-z0-9\s]/gi, "").replace(/[_\s]/g, "-").toLocaleLowerCase();
    $("#variant_selected option").each(function () {
        if (thisVariantName === $(this).data("variant-name").replace(/[^a-z0-9\s]/gi, "").replace(/[_\s]/g, "-").toLocaleLowerCase()) {
            $("#variant_selected").val($(this).val()).trigger("change");
            return false;
        }
    });
});
$(document).ready(function () {
    var currentURL = window.location.href,
        currentVariant = $('.swatch-element[data-id="' + getUrlVars(currentURL).variant + '"]');
    if (currentVariant.length) {
        currentVariant.trigger("click");
        $(".select-swatch-value").addClass("remove-bg-selected");
    }
});
function getUrlVars() {
    var vars = [],
        hash;
    var hashes = window.location.href.slice(window.location.href.indexOf("?") + 1).split("&");
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split("=");
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

$(".mobile-nav__sub__link.hide").parent().addClass("remove-category-product");

// Collection filter category
$(".category-filter-collection .facets__title").on("click", function (event) {
    $(this).parent(".category-filter-collection").toggleClass("active");
});

// remove class when click outside
$(document).on("click", function (event) {
    if (!$(event.target).closest(".category-filter-collection").length) {
        $(".category-filter-collection").removeClass("active");
    }
});

if ($(".facets__list__category").length) {
    var url = window.location.href;
    $(".facets__list__category > li > a").each(function () {
        var urla = $(this).attr("href");
        if (url == urla) {
            $(this).addClass("active-link");
        }
    });
}

// Menu tab filter category
$(".category-tab-collection .mobile-facets__submenu").on("click", function () {
    $(this).parents(".category-tab-collection").removeClass("menu-opening");
});

$(".category-tab-collection .mobile-facets__summary_category span").on("click", function () {
    $(this).parents(".category-tab-collection").addClass("menu-opening");
});

// Menu mobie
$(".menu-drawer-container .overlay-menu").on("click", function () {
    $(this).parent("#shopify-section-mobile-drawer").siblings(".header__icon--menu").trigger("click");
    $("body").find(".mobile-nav__item--sub").removeClass("active");
});

// remove class when click outside Popup bundle
$(document).on("click", function (event) {
    setTimeout(function () {
        if (!$(event.target).closest(".Modal_content_3c9D4").length) {
            $(".Modal_picky-modal_2hpGv").css("display", "none");
        }
    });
});

$(document).ready(function () {
    setTimeout(function () {
        $(".AddSelectedToCart_picky-retail-price_1bAh6").parent("div").addClass("has-sale");
    }, 5000);

    // CMS videos
    $(document).ready(function () {
        $(".grid-video .image__thumbnail, .grid-video .image-icon__play").on("click", function () {
            $(this).parents(".grid_video_item").addClass("active_video");
        });
    });

    // Breadcrumb

    $("li.breadcrumbs__item.collection_title").each(function () {
        if ($.trim($(this).text()).length == 0) {
            $(this).addClass("hide");
        }
    });

    // Menu region
    $(".menu-region .current-region a").on("click", function () {
        $(this).parents(".menu-region").toggleClass("active");
    });
});

$(document).on("click", function (event) {
    if (!$(event.target).closest(".menu-region").length) {
        $(".menu-region").removeClass("active");
    }
});

// Show more/ show less
$(".show-more").on("click", function (e) {
    e.preventDefault();
    $(this).parents().addClass("show-full");
});

$(".show-less").on("click", function (e) {
    e.preventDefault();
    $(this).parents().removeClass("show-full");
});

// Section Blog recommend in product
if ($(window).width() < 1000) {
    $(".blog__posts_articles-wrapper").slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    });
}

$(".other-articles__picture.has_video").on("click", function () {
    $(this).addClass("remove_image");
    $(".has_video_item video")[0].play();
});

// Mobile drawer styling and positioning
$(document).ready(function () {
    var styleCheckInterval = null;
    var epbContainerFound = false;
    
    function setMobileDrawerStyles() {
        var $mobileDrawer = $("#shopify-section-mobile-drawer");
        
        if ($mobileDrawer.length) {
            // Set max-width for mobile drawer when screen <= 1100px
            if ($(window).width() <= 1100) {
                $mobileDrawer.css("max-width", "1100px");
            } else {
                $mobileDrawer.css("max-width", "");
            }

            var $epbContainer = $("#epb_container");
            if ($epbContainer.length) {
                var epbHeight = $epbContainer.outerHeight() || 0;
                var headerSecondaryHeight = $("#shopify-section-header-seconary").outerHeight() || 0;
                var headerWrapperHeight = $(".header-wrapper").outerHeight() || 0;
                
                var totalTop = epbHeight + headerSecondaryHeight + headerWrapperHeight;
                $mobileDrawer.css("top", totalTop + "px");
                
                // Clear interval once epb_container is found and calculation is done
                if (!epbContainerFound && epbHeight > 0) {
                    epbContainerFound = true;
                    if (styleCheckInterval) {
                        clearInterval(styleCheckInterval);
                        styleCheckInterval = null;
                    }
                }
            }
        }
    }

    // Run on page load - check every 1 second until epb_container is found
    styleCheckInterval = setInterval(function () {
        setMobileDrawerStyles();
    }, 1000);

    // Run on window resize
    $(window).on("resize orientationchange", function () {
        setMobileDrawerStyles();
    });
});

})(jQuery);

